import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import TagManagerService from "services/TagManager";
import Search from "components/Header/Search";
import LoginService from 'services/Login/';
import useVariant from 'hooks/useVariant';
import { searchVariantID } from 'config';
import StorageService from 'services/StorageService/';
import MiniCart from 'containers/MiniCart';
import PubSub from 'services/PubSub/';
import MobileMenu from 'components/Header/MobileMenu';
import UserMenu from 'components/Header/Content/UserMenu';
import DeliverySelector from 'components/Header/DeliverySelector'
import Notifications from './Notifications';
import LoginRegister from 'components/Header/LoginRegister';
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss';//NOSONAR

let actions = [];

const HeaderContent = (props) => {
    const [isLogged, setLogged] = useState(false);
    const [firstName, setName] = useState('');
    const isMobile = useViewportMediaQuery(1121)

    const variant = useVariant(searchVariantID);
    const newVariant = variant === '1';

    useEffect(() => {
        actions.push(PubSub.register('logged_in', changeComponent));
        actions.push(PubSub.register('user_logout', changeComponent));

        Logged();
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, []);

    const changeComponent = (payload) => {
        if (payload.actionType === "logged_in"){
            setTimeout(() => Logged(), 500);
        }
        if (payload.actionType === "user_logout"){
            setLogged(false);
        }
    };

    const onClick = (action, tag) => {
        PubSub.dispatch('close_tracking');
        PubSub.dispatch('toggle_minicart', { state: false });
        PubSub.dispatch('toggle_menu', { state: false });
        TagManagerService.clickHeader(action, tag);
    };

    const Logged = () => {
        const userData = StorageService.getSecureItem('userData');

        setLogged(LoginService.isLogged());

        let name = userData.firstName;

        if(userData.email === 'pamela.ormeno@externos-cl.cencosud.com'){
            name = 'Muralla';
        } else if(userData.email === 'coloradomismael@gmail.com'){
            name = 'Patrón';
        } else if(userData.email === 'juliesozamcpherson@gmail.com'){
            name = 'Mom';
        } else if(userData.email === 'nicomasnovo@gmail.com'){
            name = 'Boludo';
        } else if(userData.email === 'comiramirez@gmail.com'){
            name = 'Conichi';
        }

        setName(name);
    };

    const openSearch = () => {
        PubSub.dispatch('open_search');
    }

    return <div className='new-header-wrapper'>
        <div className='new-header-container'>
            <Link onClick={() => onClick('Logo Jumbo', 'Header')} to="/" className="new-header-logo-link jumbo-icon-logo" aria-label="Jumbo Chile" />
            <Search />
            <div className='new-header-right-content'>
                {!isMobile && <DeliverySelector />}

                <div className={"new-header-wrap-links " + (isLogged ? ' position ' : '')}>
                    {!isLogged && <LoginRegister/>}
                    {isLogged && <UserMenu name={firstName} />}
                </div>
                {newVariant && <button onClick={openSearch} className="search-icon-mobile-wrap"><i className="search-icon-variant jumbo-icon-new-search" /></button>}
                {isMobile && isLogged && <Notifications />}
                <MiniCart />
                
                <MobileMenu categories={props.categories} fixedCategories={props.fixedCategories}/>
            </div>
            
        </div>
    </div>;
};


HeaderContent.propTypes = {
    categories: PropTypes.array,
    fixedCategories: PropTypes.array
};

export default HeaderContent;
